import React from 'react';
import { ReactComponent } from 'Common/components/Icons/instructions.svg';

const Instructions = () => <ReactComponent className="MuiSvgIcon-root" />;

export default Instructions;
